/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskIdRelatedOrgTxblCorpTr
 */
export interface ExecRiskIdRelatedOrgTxblCorpTr {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    RelatedOrganizationName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    EIN?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    PrimaryActivitiesTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    LegalDomicileStateCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    LegalDomicileForeignCountryCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    DirectControllingNACd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    EntityTypeTxt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    ShareOfTotalIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    ShareOfEOYAssetsAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    OwnershipPct?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblCorpTr
     */
    ControlledOrganizationInd?: string;
}

/**
 * Check if a given object implements the ExecRiskIdRelatedOrgTxblCorpTr interface.
 */
export function instanceOfExecRiskIdRelatedOrgTxblCorpTr(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskIdRelatedOrgTxblCorpTrFromJSON(json: any): ExecRiskIdRelatedOrgTxblCorpTr {
    return ExecRiskIdRelatedOrgTxblCorpTrFromJSONTyped(json, false);
}

export function ExecRiskIdRelatedOrgTxblCorpTrFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskIdRelatedOrgTxblCorpTr {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'RelatedOrganizationName': !exists(json, 'RelatedOrganizationName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['RelatedOrganizationName']),
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
        'EIN': !exists(json, 'EIN') ? undefined : json['EIN'],
        'PrimaryActivitiesTxt': !exists(json, 'PrimaryActivitiesTxt') ? undefined : json['PrimaryActivitiesTxt'],
        'LegalDomicileStateCd': !exists(json, 'LegalDomicileStateCd') ? undefined : json['LegalDomicileStateCd'],
        'LegalDomicileForeignCountryCd': !exists(json, 'LegalDomicileForeignCountryCd') ? undefined : json['LegalDomicileForeignCountryCd'],
        'DirectControllingNACd': !exists(json, 'DirectControllingNACd') ? undefined : json['DirectControllingNACd'],
        'EntityTypeTxt': !exists(json, 'EntityTypeTxt') ? undefined : json['EntityTypeTxt'],
        'ShareOfTotalIncomeAmt': !exists(json, 'ShareOfTotalIncomeAmt') ? undefined : json['ShareOfTotalIncomeAmt'],
        'ShareOfEOYAssetsAmt': !exists(json, 'ShareOfEOYAssetsAmt') ? undefined : json['ShareOfEOYAssetsAmt'],
        'OwnershipPct': !exists(json, 'OwnershipPct') ? undefined : json['OwnershipPct'],
        'ControlledOrganizationInd': !exists(json, 'ControlledOrganizationInd') ? undefined : json['ControlledOrganizationInd'],
    };
}

export function ExecRiskIdRelatedOrgTxblCorpTrToJSON(value?: ExecRiskIdRelatedOrgTxblCorpTr | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RelatedOrganizationName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.RelatedOrganizationName),
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
        'EIN': value.EIN,
        'PrimaryActivitiesTxt': value.PrimaryActivitiesTxt,
        'LegalDomicileStateCd': value.LegalDomicileStateCd,
        'LegalDomicileForeignCountryCd': value.LegalDomicileForeignCountryCd,
        'DirectControllingNACd': value.DirectControllingNACd,
        'EntityTypeTxt': value.EntityTypeTxt,
        'ShareOfTotalIncomeAmt': value.ShareOfTotalIncomeAmt,
        'ShareOfEOYAssetsAmt': value.ShareOfEOYAssetsAmt,
        'OwnershipPct': value.OwnershipPct,
        'ControlledOrganizationInd': value.ControlledOrganizationInd,
    };
}

